<template>
  <div id="home-residents" class="fade-in-fast">
    <HomeFeaturedHeader title="meet our residents" :route="{ name: 'Residents' }" />
    <LoadingItems v-if="!residentsData.length"
                  :circle="true"
                  :height="350"
    />
    <HomeResidentsCarousel v-else :featured-data="residentsData" />
  </div>
</template>
<script>
import axios from 'axios';
import HomeFeaturedHeader from '@/components/sections/HomeFeaturedHeader.vue';
import HomeResidentsCarousel from '@/components/sections/HomeResidentsCarousel.vue';
import LoadingItems from '@/components/ui/LoadingItems.vue';
export default {
  name: 'HomeResidents',
  components: {
    HomeFeaturedHeader,
    HomeResidentsCarousel,
    LoadingItems
  },
  data: () => ({
    residentsData: []
  }),
  mounted() {
    this.getFeaturedResidents();
  },
  methods: {
    getFeaturedResidents() {
      axios
        .get(this.$router.options.api + '/front/artist-module?type=MEET_OUR_RESIDENTS')
        .then(response => (this.residentsData = response.data))
        .catch(error => console.error(error));
    }
  }
};
</script>
<style scoped lang="scss">
@import '@/assets/sass/abstracts/_variables.scss';
.home-residents {
  position: relative;
  padding-bottom: 50px;
}
div#resident-carousel {
  position: relative;
}
</style>
